import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, user } = useContext(AuthContext);
  const location = useLocation();

  /**
   * 🚫 Not logged in → go to login
   */
  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}
      />
    );
  }

  /**
   * 🚫 Role-based restriction (ONLY when allowedRoles is specified)
   * - ADMIN is allowed anywhere unless explicitly restricted
   * - EMPLOYEE is restricted from ADMIN-only routes
   */
  if (
    allowedRoles &&
    user?.role &&
    !allowedRoles.includes(user.role)
  ) {
    return <Navigate to="/unauthorized" replace />;
  }

  /**
   * ✅ Allowed → render page
   */
  return children;
};

export default ProtectedRoute;
